import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";

export function useEntityNotePermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  return {
    canAddCaseNotes: permissions.includes("core.add_note"),
    canEditCaseNotes: permissions.includes("core.change_note"),
    canSeeAISummary: permissions.includes("call_log.view_callsummary"),
  };
}
